<template>
  <div v-if="token.role === 'ADM'">
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Empresas</h5>
      </div>
    </div>
    <hr>
    <div class="row" >
      <div class="col">
        <router-link :to="`${route}/novo`" class="btn btn-block btn-primary btn-raised">
          + Adicionar um nova empresa
        </router-link>
        <hr>
      </div>
    </div>

    <div class="row">

      <div class="col">
        <div class="alert alert-warning" role="alert" v-if="data.length === 0">
          Nenhum registro cadastrado.
        </div>
        <table class="table table-sm">
          <thead class="thead-light">
            <tr>
              <th scope="col">Empresa</th>
              <th scope="col">Plano</th>
              <th scope="col">Expiração</th>
              <th scope="col">Opções</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="item in data" :key="item._id">
                <td scope="row">
                  {{item.nome}}
                </td>
                <td>
                  {{item.plano ? item.plano.nome : ''}}
                </td>
                <td>
                  {{formatar(item.expiraEm)}}
                </td>
                <td>
                  <router-link class="btn btn-raised btn-warning btn-sm" title="Edit" :to="`${route}/edit/${item._id}`">
                    Alterar
                  </router-link>
                  <a class="btn btn-raised btn-danger btn-sm"  href="javascript:;" @click.prevent="remove(item._id)" title="Remove">Remover</a>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>

    <hr>
    <div class="row" v-if="data.length > 0">
      <div class="col">
          <pagination :records="total" :options='pagOpts' :per-page="perPage" @paginate="setPage">
          </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      data: [],
      route: '/admin/empresas',
      page: 1,
      perPage: 10,
      total: 0,
      pagOpts: this.$custom.pagOpts,
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/admin/empresas/upload`,
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      )
    };
  },
  methods: {
    remove(id) {
      this.$http.delete(`${this.route}/${id}`).then(() => {
        this.setPage(this.page);
      });
    },
    setPage: function(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;

      let url = `${this.route}/list`;

      this.$http.post(url, { skip, limit }).then(response => {
        this.data = response.data.data;
        this.total = response.data.total;
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    }
  },
  beforeMount() {
    this.setPage(1);
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/admin/empresas/Home.vue